<template>
    <img class="demo-bg" :src="bgImage" alt="" />

    <div class="background-container">
        
        <v-container style="margin-bottom: 10px; padding: 30px" class="box-container white-box">
            <h1 class="title" :style="{ backgroundColor: color }">
                Endeavour Sports Park: Free Booking Night
            </h1>
            <!-- booking information page -->
            
        <div v-if="status===''">
                <!-- First Name -->
                <FormKit label="Club Name *" readonly type="text" validation="alpha_spaces_hyphens:latin|required"
                    placeholder="John Doe" v-model="formData.name" validation-label="Name" />

                <!-- Email address -->
                <FormKit label="Email *" readonly type="email" validation="required|email" placeholder="johnd@mail.com"
                    v-model="formData.email" validation-label="email" />

                <!-- Mobile Number -->
                <FormKit label="Mobile Number *" readonly type="tel" validation="required|matches:/^[0-9]{10}$/"
                    :validation-messages="{
                        matches: 'Mobile number must be of 10 digits',
                    }" placeholder="0412345678" v-model="formData.mobileNumber" validation-label="Mobile Number" />

                <!--
                <div class="form-section">
                <div class="col-lg-5">
                
                            <v-img @click="openvenueImage" :src='qrImage' alt=""  class="qrimage"> </v-img>
                        </div>
                        </div>     
                        
                <v-dialog v-model="showzoomedImage" class="openimage" width="3000">
                        <v-row>
                        <v-img :src='qrImage' alt=""> </v-img>
                        <v-btn
                        style="height: 26px; width: 27px"
                            icon
                            dark
                            @click="showzoomedImage = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        </v-row>
                    </v-dialog> -->


                <!-- Court use -->
                <FormKit label="Booking Selection(4 PM to 10 PM)" type="select" :options="slots" name="AvailableSlots"
                    id="availableslots" validation-label="Available Slots" placeholder="Please select a slot"
                    v-model="formData.slotid" />

                <!-- Booking Name -->
                <!-- <FormKit label="Booking Name *" type="text" validation="alpha_spaces_hyphens:latin|required" placeholder="Booking Name"
                v-model="formData.bookingname" validation-label="Booking Name" /> -->

                <!-- Booking note -->
                <!-- <FormKit
                label="Booking Note"
                placeholder="Remember to write in complete sentences."
                rows="10"
                type="textarea"
                validation="=length:5,1000"
                validation-label="booking note"
                v-model="formData.bookingnote"
              /> -->

                <h4 class="tnc">Terms and Conditions</h4>

                <ul class="listoftnc">
                    <li>One free booking night per club</li>

                    <li>Council does not provide transfers, in the event of: </li>
                    <ul>
                        <li>Adverse weather conditions (such as excessive heat, rain, storms, hail, etc.) </li>

                        <li>Incorrect booking times or dates </li>
                        <li>Any actions or events beyond Council’s control Council reserves the right to cancel any hire
                            or
                            fixture if the area is deemed unfit for play or if the probable damage resulting from such
                            play
                            would be detrimental to the future use of the area. </li>
                    </ul>
                    <li>Council may close the sportsfields due to extreme dangerous weather conditions without prior
                        notice.
                        The hirer is responsible for inspecting the site immediately before and during any activity.
                    </li>

                    <li>No access to change rooms </li>

                    <li>Watercoooling system will not be available</li>

                    <li>Canteen facilities will not be available</li>

                    <li>No storage facilities available.</li>

                    <li>SHOE POLICY Users must wear appropriate footwear designed for synthetic fields. Heels, metal
                        studded
                        boots, and any other footwear deemed unsuitable are strictly prohibited, as they can damage the
                        playing surface. Damage to the fields may result in their temporary closure</li>

                    <li>PLAY SURFACE The Hirer may not use any item or equipment. This includes, but is not limited to,
                        motorbikes, bicycles, scooters, remote control cars, skateboards, rollerblades, cricket bats,
                        hockey
                        sticks, and similar hard or wheeled items. Personal training and heavy items such as dumbbells,
                        kettlebells, sledges, ladder drills, machine ball smashes are strictly prohibited.</li>

                    <li>The hirer must respect other hirers by ensuring the facility is vacated on time</li>

                    <li>CONDUCT AND BEHAVIOUR Aggressive behaviour, harassment, or any form of disturbances within the
                        fields, car parks, or surrounding areas is strictly prohibited. Excessive noise that disrupts
                        other
                        users or nearby residents will not be tolerated. Hirers are responsible for managing the conduct
                        and
                        behaviour of all participants during their hire period.</li>
                </ul>

                <FormKit label="I have read, understood and will abide by the conditions/terms of use. *" name="terms"
                    type="checkbox" validation="accepted" validation-label="terms and conditions"
                    v-model="formData.acceptTerms" />
                <div class="button-container">
                    <v-btn
                        class="booking-theme-btn"
                        :style="{ backgroundColor: buttonColor, color: 'var(--booking-button-font-color)' }"
                        :disabled="isFormIncomplete"
                        variant="flat"
                        @click="submitBooking"
                    >
                        Make a booking
                    </v-btn>
                </div>
            </div>
        </v-container>
        <div v-if="status === 'success'" class="message-box _success">
            <i class="fa fa-check-circle" aria-hidden="true"></i>
            <h2>Your booking was successful</h2>

            <p>
                Thank you for your booking. You will receive an email and SMS with the booking details shortly.
            </p>
            <div>
                <button class="success-button" @click="redirectTohomepage">BACK TO WEBSITE</button>
            </div>
        </div>
        <div v-if="status === 'failed'" class="message-box _error">
            <i class="fa-solid fa-circle-xmark"></i>
            <h2>Booking failed.</h2>
            <p>
                {{ failMessage }}
            </p>

            <p>
                For any issues, please contact Council by calling 9725 0222 during business hours. After 5:00pm call
                9725 0222 and press option 2.
            </p>
            <div>
                <button class="_error-button" @click="redirectTohomepage">BACK TO WEBSITE</button>
            </div>

        </div>
    </div>
</template>

<script>
import { createFreeSingleBookingWithForm, GetFreeSlots, verifyOnetimeToken, checkExistingOnetimeUser } from "../../../../server/config";
import { getBookingGeneral } from "../../../store/vuexStore";
import { applyBookingTheme } from "@/utils/bookingTheme.js";
import { getOtpSession, syncLegacyOtpSessionFromStorage } from "@/utils/otpSession.js";
// import EndeavourCourtSignin from "@/assets/EndeavourCourtSignin.jpg"

export default {
    data: () => ({
        overlay: false,
        bgImage: "",
        color: "",
        buttonColor: "",
        slots: [],
        showzoomedImage: false,
        qrImage: "",
        formData: {
            otpid: '',
            name: '',
            email: '',
            mobileNumber: '',
            slotid: '',
            acceptTerms: false
        },
        status:'',
        failMessage:'',

    }),

    methods: {
        setData() {
            this.data = getBookingGeneral() || {};
            applyBookingTheme(this.data);
            this.bgImage = this.data.homepageimage;
            this.color = this.data.color;
            this.buttonColor = this.data.buttoncolor || "#0275FF";
        },
        async submitBooking() {
            if (this.formData.slotid === '') {
                alert("Please select a booking slot.");
                return;
            }

            const result = await createFreeSingleBookingWithForm(this.formData);
            const status = result?.status;
            const message =
              result?.data?.message ||
              result?.data?.error ||
              result?.data?.response ||
              "";

            if (status === 200) {
                sessionStorage.clear();
                this.status = 'success';
            } else if (status === 409) {
                this.status = 'failed';
                this.failMessage = message || "You have already made a free booking this season, please contact facility management for further assistance."
            } else if (status === 422) {
                this.status = 'failed';
                this.failMessage = message || "The selected slot is no longer available. Please go back and select a different slot."
            } else {
                this.status = 'failed';
                this.failMessage = message || "An unexpected error occurred. Please try again later."
            }
        },
        async freeslots() {
            const slotsData = await GetFreeSlots();

            if (slotsData.length === 0) {
                alert("No free slots available at the moment. Please try again later.");
                this.$router.push({ path: `/bookingapp/endeavourclubs/` });
                return;
            }
            this.slots = slotsData;
        },
        redirectTohomepage() {
            this.$router.push({ path: `/bookingapp/endeavourclubs/` });
        },
        // openvenueImage() {
        //   this.showzoomedImage = true;
        // },
    },
    async created() {
        this.setData();
        this.overlay = false;
        this.qrImage = 'https://i.imgur.com/ZQIzJmB.png'
        this.freeslots();
    },
    computed: {
        isFormIncomplete() {
            return Object.values(this.formData).some((value) => value === '' || value === false);
        },

    },
    async beforeCreate() {
        let token = sessionStorage.getItem("onetimeToken");
        const verifyToken = await verifyOnetimeToken(token);

        if (!verifyToken || verifyToken.status !== 1) {
            this.$router.push({ path: `/bookingapp/endeavourclubs/` });
        }

        syncLegacyOtpSessionFromStorage();
        const session = getOtpSession();
        let email = session?.email || sessionStorage.getItem("email");
        let venueType = session?.venueType || sessionStorage.getItem("selectedvenuetype");

        if (session?.otpUserId) {
            this.formData.otpid = session.otpUserId;
            if (session.profile) {
                this.formData.name = `${session.profile.firstname || ""} ${session.profile.lastname || ""}`.trim();
                this.formData.email = session.profile.email || email || "";
                this.formData.mobileNumber = session.profile.phone || "";
            }
            return;
        }

        const user = await checkExistingOnetimeUser(email, venueType);
        if (!user || user.status !== 1 || user.response.id == '') {
            alert("Something went wrong while fetching user data. Please try again.");
            this.$router.push({ path: `/bookingapp/endeavourclubs/` });
        }
        this.formData.name = user.response.firstname + ' ' + user.response.lastname;
        this.formData.email = user.response.email;
        this.formData.mobileNumber = user.response.phone;
        this.formData.otpid = user.response.id;
    },
};
</script>

<style src="./endeavourFreeBooking.css"></style>
